import type { IMenuPath } from '~~routes/PathConstants';
import type { IGetListParams, IGetListResponse } from '~~utils/ConstantTypes';
import AxiosApiClient from './AxiosApiClient';

export type IGetUserParams = {
  email: string,
  phone: string,
  web_user_name: string,
};
export type IUserItem = {
  web_user_id: number,
  web_user_name: string,
  email: string,
  phone: string,
};
export const getUsers = (payload: IGetListParams<IGetUserParams>) => (
  AxiosApiClient.cancelPost<IGetListResponse<IUserItem>>('user/getUsers', payload)
);

type IGetUserDetailParams = {
  web_user_id: number,
};
export const getUserDetail = (payload: IGetUserDetailParams) => AxiosApiClient.cancelPost<IUserItem>('user/getUserDetail', payload);

type IAddUserParams = {
  web_user_name: string,
  email: string,
  phone: string,
};
export const addUser = (payload: IAddUserParams) => AxiosApiClient.errorPost('user/addUser', payload);

interface IEditUserParams extends IAddUserParams {
  web_user_id: number,
}
export const editUser = (payload: IEditUserParams) => AxiosApiClient.errorPost('user/updateUser', payload);

export const deleteUser = (payload: IGetUserDetailParams) => AxiosApiClient.errorPost('user/deleteUser', payload);

export type IUserProfileResponse = {
  email: '',
  need_reset_password: false,
  phone: '',
  profile_photo: '',
  web_user_name: '',
};
export const getUserProfile = () => AxiosApiClient.post<IUserProfileResponse>('/user/getUserProfile');

export type IUpdateProfileParams = {
  phone?: string,
  profile_photo?: string,
  old_password?: string,
  new_password?: string,
};
export const updateUserProfile = (payload: IUpdateProfileParams) => AxiosApiClient.errorPost('/user/updateUserProfile', payload);

type ICheckPasswordParams = {
  password: string,
};
export const checkPassword = (payload: ICheckPasswordParams) => AxiosApiClient.post('user/checkPassword', payload);

export const getMenu = () => AxiosApiClient.cancelPost<IMenuPath>('/user/getMenu');

export const logout = () => AxiosApiClient.post('user/logout');
